import template from './quote-request.template.html';
import {QuoteRequestController} from "./quote-request.controller";

export class QuoteRequestService {

    constructor($log, $uibModal) {
        'ngInject';

        this.$log = $log;
        this.$uibModal = $uibModal;

    }

    open() {

        let modalInstance = this.$uibModal.open({
            templateUrl: template,
            controller: QuoteRequestController,
            controllerAs: '$ctrl'
        });

        modalInstance.result.then(() => {

        }, () => {
            this.$log.info('Modal dismissed at: ' + new Date());
        });

    }

}



// WEBPACK FOOTER //
// ./src/js/components/quote-request/quote-request.service.js